import { render, staticRenderFns } from "./TabsVue.vue?vue&type=template&id=5127ffdc&scoped=true&"
import script from "./TabsVue.vue?vue&type=script&lang=js&"
export * from "./TabsVue.vue?vue&type=script&lang=js&"
import style0 from "./TabsVue.vue?vue&type=style&index=0&id=5127ffdc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5127ffdc",
  null
  
)

export default component.exports